export default "__VITE_ASSET__1e6ed099__"